import { alpha, MenuItem as MuiMenuItem, styled } from '@mui/material';

export const SubmenuCollapse = styled('div', {
  shouldForwardProp: (prop) => prop !== 'open',
})<{ open: boolean }>(({ open }) => ({
  display: 'grid',
  gridTemplateRows: open ? '1fr' : '0fr',
  visibility: open ? 'visible' : 'hidden',
  transition: `grid-template-rows 200ms ease, visibility 0s linear ${open ? '0ms' : '200ms'}`,
}));

export const SubmenuCollapseInner = styled('div')({
  overflow: 'hidden',
  minHeight: 0,
});

export const NestedDropdownWrapper = styled('div')(() => ({
  margin: '0 10px',
}));

interface SubMenuItemProps {
  active: boolean;
  nested?: boolean;
}

export const SubMenuItem = styled(MuiMenuItem, {
  shouldForwardProp: (prop) => prop !== 'disableScrollLock' && prop !== 'active' && prop !== 'nested',
})<SubMenuItemProps>(({ theme, active, nested }) => ({
  // Direct subitem: 10px margin + 44px left padding = 54px (aligns with main text start)
  // Nested subitem: 0 margin + 46px left padding (inside NestedDropdownWrapper with 10px margin)
  padding: nested ? '8px 8px 8px 46px' : '8px 8px 8px 44px',
  margin: nested ? '6px 0' : '6px 10px',
  borderRadius: '12px',
  backgroundColor: active ? alpha(theme.palette.text.primary, 0.06) : 'transparent',
  transition: 'background-color 120ms ease, color 120ms ease',
  alignItems: 'center',
  minHeight: '48px',
  color: theme.palette.text.primary,
  '&:hover': {
    backgroundColor: active ? alpha(theme.palette.text.primary, 0.08) : alpha(theme.palette.text.primary, 0.04),
  },
  '&.Mui-focusVisible': {
    backgroundColor: active ? alpha(theme.palette.text.primary, 0.08) : alpha(theme.palette.text.primary, 0.04),
  },
  '&:focus': {
    backgroundColor: active ? alpha(theme.palette.text.primary, 0.06) : 'transparent',
  },
}));

export const SubMenuText = styled('span')<{ active?: boolean }>(({ active, theme }) => ({
  flex: 1,
  minWidth: 0,
  whiteSpace: 'normal',
  overflowWrap: 'break-word',
  fontSize: '12px',
  fontWeight: active ? 500 : 400,
  lineHeight: '20px',
  color: active ? theme.palette.text.primary : theme.palette.text.secondary,
  letterSpacing: '-0.01em',
}));

export const SubTextBadgeGroup = styled('div')(() => ({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  minWidth: 0,
  overflow: 'hidden',
}));
